import React from "react";
import { Box } from "@material-ui/core";
import Header from "./Header";
import Footer from "./Footer";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  content: {
    minHeight: "100vh",
    border: "2px solid #000",
    position: "relative",
    zIndex: theme.zIndex.phoneNumber,
    [theme.breakpoints.up("md")]: {
      display: "grid",
      gridTemplate: "min-content auto min-content / 1fr",
      paddingBottom: 0,
    },
  },
  stepContainer: {
    width: "100%",
    margin: theme.spacing(0, "auto"),
    zIndex: 100,

    "&::after": {
      content: '""',
      clear: "both",
      display: "table",
    },

    [theme.breakpoints.up("sm")]: {
      maxWidth: "600px",
    },
    [theme.breakpoints.up("md")]: {
      maxWidth: "900px",
    },
  },
}));

const Layout = ({ children }) => {
  const classes = useStyles();

  return (
    <div className={classes.content}>
      <Header />

      <Box className={classes.stepContainer}>{children}</Box>

      <Footer />
    </div>
  );
};

export default Layout;
